<script setup>
import { ref, watch, computed } from 'vue';
import { useStore, useMapGetter } from 'dashboard/composables/store';
import { useI18n } from 'vue-i18n';
import { useAlert } from 'dashboard/composables';
import { useVuelidate } from '@vuelidate/core';
import { required, helpers } from '@vuelidate/validators';
import WootSubmitButton from 'dashboard/components/buttons/FormSubmitButton.vue';
import { ElUpload, ElButton, genFileId, ElMessageBox } from 'element-plus';
import Auth from '../../../../../api/auth';

// 使用 defineProps 来接收 props
const props = defineProps({
  merchant: Object, // 接收 merchant 对象
  submitData: Function, // 接收父组件传递的 submitData 方法
});
const emit = defineEmits(['close']);

const store = useStore();
const { t } = useI18n();
const { thirdHostURL = '' } = window.chatwootConfig || {};
const actionURL = `${thirdHostURL}/v1/api/chatapp/merchant/file`
// 获取 ElUpload 实例
const fileUrlList = ref([]);
const isLoading = ref(false);
const uploadRef = ref();
const fileList = ref([])
const talkURL = `${window?.chatwootConfig?.viteLivePreviewURL}${window?.chatwootConfig?.viteCustomerServiceTalkURL}`

// 自定义数组长度验证器（最少1个，最多10个）
const maxArrayLength = helpers.withMessage(
  t('BILLING_SETTINGS.MANAGE_SUBSCRIPTION.UPLOAD_SCRIPT_FILE_LIMIT_DESC'),
  value => Array.isArray(value) && value.length <=10
);

const minArrayLength = helpers.withMessage(
  t('BILLING_SETTINGS.MANAGE_SUBSCRIPTION.UPLOAD_SCRIPT_FILE_MIN_LIMIT_DESC'),
  value => Array.isArray(value) && value.length < 1
);

const rules = {
  fileUrlList: { required },
};

const v$ = useVuelidate(rules, {
  fileUrlList,
  minArrayLength,
  maxArrayLength
});

const uiFlags = useMapGetter('agents/getUIFlags');

const headers = computed(() => {
  let {
    'access-token': accessToken,
    'token-type': tokenType,
    client,
    expiry,
    uid,
    authorization
  } = Auth.getAuthData();
  if (!authorization) {
    let data = {
      "access-token": accessToken,
      "client": client,
      "expiry": expiry,
      "token-type": tokenType,
      "uid": uid
    }
    const jsonString = JSON.stringify(data);
    authorization = btoa(jsonString);
  }
  return {
    "authorization": authorization,
  };
});

const handleExceed = (files, uploadFiles) => {
  // if (uploadRef.value) {
  //   uploadRef.value.clearFiles() // 清空当前上传队列
  //   const file = files[0]
  //   file.uid = genFileId() // 生成唯一 ID
  //   uploadRef.value.handleStart(file) // 重新添加新文件
  //   uploadRef.value.submit() // 重新上传
  // }
  console.info(files, uploadFiles);
}

// 监听 merchant 对象的变化
watch(
  () => props.merchant,
  (newMerchant) => {
    console.info(newMerchant?.fileUrlList, "=newMerchant?.fileUrlList=")
    if (newMerchant?.fileUrlList) {
      // 如果 accessTokenList 非空，取第一个元素，否则赋空字符串
      const rawList = Array.isArray(newMerchant?.fileUrlList) ? newMerchant.fileUrlList : [];
      const latestList = rawList.map(item => {
        const url = typeof item === 'string' ? item : item?.value;
        const name = url ? decodeURIComponent(url.split('/').pop()) : '';
        return { url, name };
      }).filter(f => f.url);
      fileList.value = latestList;
      fileUrlList.value = newMerchant?.fileUrlList || [];
      console.info(fileList, fileUrlList, "=newMerchant?.fileUrlList=")
    }
  },
  { immediate: true } // 初始时就执行一次
);

const writeShop = async () => {
  v$.value.$touch();
  console.info(v$.value, v$.value.$invalid, "===========writeShop==============")
  if (v$.value.$invalid) return;
  if (isLoading.value) {
    console.info("重复点击拦截")
    return;
  }
  isLoading.value = true;


  try {
    const params = {
      fileUrlList: fileUrlList.value,
    }
    console.info(params, "=========params=======")
    const result = await props.submitData(params);
    if (result) {
      useAlert(t('BILLING_SETTINGS.MANAGE_SUBSCRIPTION.SAVE_GPT_SHOP_SUCCESS'));
      emit('close');
    }
    isLoading.value = false;
  } catch (error) {
    useAlert(error?.message);
    isLoading.value = false;
  }
};

const handleRemove = (uploadFile, uploadFiles) => {
  console.info(uploadFile, uploadFiles, "===============================")
  let dataList = []
  uploadFiles.forEach(item => {
    if (item.url) {
      dataList.push({ url: item.url, name: getDocsUrl(item.url) })
    }
  })
  fileList.value = dataList
  fileUrlList.value = dataList.map(item => item.url)
}

const getDocsUrl = (fileUrl) => {
  if (!fileUrl) {
    return this.$t("BILLING_SETTINGS.MANAGE_SUBSCRIPTION.SCRIPT_EMPTY")
  }
  const decodedUrl = decodeURIComponent(fileUrl);
  const fileName = decodedUrl.substring(decodedUrl.lastIndexOf('/') + 1);
  return fileName
}

const handleFileSuccess = (response, uploadFile, uploadFiles) => {
  console.info(response, uploadFile, "==========================", uploadFiles)
  if (response?.code != 200) {
    useAlert(t('BILLING_SETTINGS.MANAGE_SUBSCRIPTION.UPLOAD_GPT_SPEECH_WORD_FAIL'));
  } else {
    console.info(response?.data, "==========================", getDocsUrl(response?.data?.url))
    let dataList = []
    uploadFiles.forEach(item => {
      if (item?.response) {
        if (item?.response?.code == 200) {
          dataList.push({ url: item?.response?.data?.url, name: getDocsUrl(item?.response?.data?.url) })
        }
      } else if (item.url) {
        dataList.push({ url: item.url, name: getDocsUrl(item.url) })
      }
    })
    console.info(dataList, "----")
    fileList.value = dataList
    fileUrlList.value = dataList.map(item => item.url)
    console.info(fileList.value, "------123------", fileUrlList.value)
  }
}

const handleFileError = (error, uploadFile) => {
  useAlert(t('BILLING_SETTINGS.MANAGE_SUBSCRIPTION.UPLOAD_GPT_SPEECH_WORD_FAIL'));
}
</script>

<template>
  <div class="flex flex-col h-auto overflow-auto">
    <woot-modal-header :header-title="$t('BILLING_SETTINGS.MANAGE_SUBSCRIPTION.GPT_TALK_TITLE')"
      :header-content="$t('BILLING_SETTINGS.MANAGE_SUBSCRIPTION.GPT_TALK_CONTENT')" />
    <form class="flex flex-col items-start w-full" @submit.prevent="writeShop">
      <div class="mb-4">
        <a target="_blank" :href="talkURL" class="text-woot-500 dark:text-woot-500 !p-0">
          {{ $t(`BILLING_SETTINGS.MANAGE_SUBSCRIPTION.GPT_THIRD_PARTY_SHOPIFY_KEY_TIPS`) }}
        </a>
      </div>
      <div class="w-full">
        {{ $t('BILLING_SETTINGS.MANAGE_SUBSCRIPTION.GPT_THIRD_PARTY_SPEECH_FILE_LABEL') }}
        <ElUpload ref="uploadRef" :multiple="true" v-model:file-list="fileList" :headers="headers" :action="actionURL"
          :auto-upload="true" :on-remove="handleRemove" :on-success="handleFileSuccess" :on-error="handleFileError"
          :limit="10" :on-exceed="handleExceed">
          <ElButton type="primary">{{ $t(`BILLING_SETTINGS.MANAGE_SUBSCRIPTION.UPLOAD_GPT_SPEECH_WORD_TITLE`) }}
          </ElButton>
          <template #tip>
            <div class="el-upload__tip">
              {{ $t('BILLING_SETTINGS.MANAGE_SUBSCRIPTION.UPLOAD_SCRIPT_FILE_LIMIT_DESC') }} ({{ (fileList?.length || 0) }}/ 10)
            </div>
          </template>
        </ElUpload>
        <label :class="{ error: v$.fileUrlList.$error }"></label>
      </div>

      <div class="flex flex-row justify-end w-full gap-2 px-0 py-2">
        <div class="w-full">
          <WootSubmitButton :disabled="v$.$invalid || uiFlags.isCreating"
            :button-text="$t('BILLING_SETTINGS.MANAGE_SUBSCRIPTION.GPT_THIRD_PARTY_SAVE_TITLE')" :loading="isLoading" />
          <button class="button clear" @click.prevent="emit('close')">
            {{ $t('AGENT_MGMT.ADD.CANCEL_BUTTON_TEXT') }}
          </button>
        </div>
      </div>
    </form>
  </div>
</template>
